module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step2_Image3e.9ee4b6f5.jpg";